// extracted by mini-css-extract-plugin
module.exports = {"faqsPageWrapper":"FaqsPage_faqsPageWrapper__CEdFD"};